<main>
  <loading-overlay [isLoading]="isloading > 0" />

  <section class="content">
    <div class="page__title">
      <div class="page__title_container">
        <h1>Finishing Dashboard</h1>
      </div>
    </div>

    <div class="cs-page-list-grid">
      <p-panel [header]="'Finishing Dashboard'">
        <p-card>
          <div class="col">
            <p-autoComplete
              [placeholder]="'Search machine'"
              inputStyleClass="w-full"
              styleClass="w-full"
              [suggestions]="filteredAssets()"
              [field]="'assetId'"
              (completeMethod)="filterMachineByTerm($event)"
              (onClear)="onClearSearch()"
              [showClear]="true"
            />
            <div class="grid-auto-3">
              @if (allAssets().length > 0) {
                @for (asset of filteredAssets(); track asset.id) {
                  <div class="span-1">
                    <app-finishing-card [asset]="asset" />
                  </div>
                }
              } @else {
                <p class="text-center text-xl font-bold">No assets available</p>
              }
            </div>
          </div>
        </p-card>
      </p-panel>
    </div>
  </section>
</main>
